<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <component :is="currentComponent" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <router-view />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AginovaMonitorBar from '@/Core.Service.Domain/Monitors/Aginova/Components/AginovaMonitorBar.vue';

export default {
  name: 'MonitorsView',

  components: {
    AginovaMonitors: AginovaMonitorBar,
  },

  data(instance) {
    return {
      currentComponent: instance.$route.meta.monitorsTypeName,
    };
  },

  watch: {
    $route() {
      this.currentComponent = this.$route.meta.monitorsTypeName;
    },
  },
};
</script>
